<template>
  <div class="main-container">
    <div class="nav-container">
      <img
        src="/img/styleguide/p2a-logo.svg"
        class="p2a-logo">
    </div>
    <div class="center-container">
      <div class="text-container">
        <p class="body-stat-text--xl congratulations">Congratulations!</p>
        <p class="body-stat-text--lg unsubscribe-message">Your email unsubscribe link is <span class="working-color">working!
          <icon
            :icon-name="iconNames.CHECK_CIRCLE"
            class="check-circle-icon"
            view-box="0 0 24 24"
          />
        </span></p>
        <p class="body-text--lg unsubscribe-message-text">
          You can't unsubscribe from test emails, but your advocates will successfully opt out of your email program when they click on your unsubscribe link.
        </p>
        <a :href="backUrl">
          <button class="btn--base btn--lg btn--action btn--secondary">
            <icon
              :icon-name="iconNames.ARROW_LEFT"
              view-box="0 0 12 12"
            />
            <span class="body-text--sm body-text--semibold">Back to dashboard</span>
          </button>
        </a>

      </div>
      <div class="img-container">
        <img 
          src="/img/styleguide/illustrations/emailer-empty.svg" 
          class="emailer-empty">
      </div>
    </div>
  </div>
</template>
<script>
import * as ICON_NAMES from "Constants/styleguide/iconNames";
import Icon from "StyleguideComponents/Icon.vue";

export default {
  name: "TestEmailUnsubscribe",
  components: {
    Icon
  },
  props: {
    backUrl: {
      type: String,
      default: "https://admin.phone2action.com/emailer"
    }
  },
  data() {
    return {
      iconNames: ICON_NAMES
    };
  }
};
</script>
<style lang="scss">
@import "~StyleguideAssets/scss/master.scss";

body {
  background-color: white;
}

p,
button,
.img-container {
  margin: 10px;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: self-start;
}
.nav-container {
  margin-top: 33px;
  margin-left: 32px;
  justify-content: left;
}
.p2a-logo {
  width: 165px;
  height: 80px;
  display: block;
  margin: 0.5rem auto;
  max-height: 12.5rem;
  max-width: 12.5rem;
}
.center-container {
  margin-top: 180px;
  margin-left: 10%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.text-container,
.img-container {
  width: 45%;
}
.text-container > p.congratulations {
  color: rgba($sapphire, 0.71);
  font-weight: 600;
  font-size: 64px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 0px;
}
.text-container > p.unsubscribe-message {
  margin-top: 5px;
  font-stretch: normal;
  font-style: normal;
  font-size: 38px;
  line-height: 1.25;
  letter-spacing: normal;
  color: #212b36;
}
.check-circle-icon {
  background-color: white;
  fill: white;
  stroke: #89dcb4;
}
.unsubscribe-message-text {
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.48;
  letter-spacing: normal;
}

.emailer-empty {
  width: 462px;
  height: 321px;
  object-fit: contain;
}

.working-color {
  color: #89dcb4;
}

button {
  width: 237px;
  height: 38px;
  border-radius: 1.6px;
  box-shadow: 0 2px 5px 0 rgba(175, 175, 175, 0.2);
  border: solid 0.8px $sapphire;
}

@media (max-width: 1000px) {
  .center-container {
    flex-direction: column-reverse;
    margin-top: 100px;
  }
  .text-container {
    width: 60%;
  }
  .img-container {
    margin-bottom: 10%;
  }
}

@media (max-width: 800px) {
  .center-container {
    margin-left: 0;
  }
  .text-container {
    width: 100%;
  }
}
</style>
